import { getCountries, getCountryCallingCode } from "libphonenumber-js";
import { JobsCountryOption } from "@/types/country";

let cached: JobsCountryOption[] | null = null;

/**
 * Every dialling code with its country name, built once per page.
 *
 * Deliberately not computed during server render. Intl.DisplayNames disagrees
 * between the two runtimes -- Node's ICU calls FK "Falkland Islands" and Chrome
 * calls it "Falkland Islands (Islas Malvinas)" -- so rendering this list on the
 * server hands the client a tree it will not reproduce, and hydration fails.
 * Callers pair it with useClientValue and NO_COUNTRY_OPTIONS.
 *
 * The result is cached because useSyncExternalStore compares snapshots with
 * Object.is, and a fresh array every render never compares equal.
 */
export function getCountryOptions(): JobsCountryOption[] {
  if (!cached) {
    const regionNames = new Intl.DisplayNames(["en"], { type: "region" });
    cached = getCountries().map((code) => ({
      code,
      name: regionNames.of(code) || code,
      callingCode: getCountryCallingCode(code),
    }));
  }
  return cached;
}

/** Stable empty snapshot for the server and the first client render. */
export const NO_COUNTRY_OPTIONS: JobsCountryOption[] = [];
